import { render, staticRenderFns } from "./JudgeResult.vue?vue&type=template&id=64e4bbc8&scoped=true&"
import script from "./JudgeResult.vue?vue&type=script&lang=js&"
export * from "./JudgeResult.vue?vue&type=script&lang=js&"
import style0 from "./JudgeResult.vue?vue&type=style&index=0&id=64e4bbc8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e4bbc8",
  null
  
)

export default component.exports